export const careersV2URL = "/careers";
export const careersV3URL = "/careers-v3";
export const careersV4URL = "/careers-v4";
export const careersV5URL = "/careers-v5";
export const careerListingURL = "/careers-details";